import styled, { createGlobalStyle } from 'styled-components';
import { Map as LeafletMap } from 'react-leaflet';
import { Card } from '~/components';
import {
  AA_LINK_ON_LIGHT,
  AA_LINK_HOVER_ON_LIGHT,
  AA_TEXT_ON_LIGHT,
  AA_SURFACE,
} from '~/modules/Helper/contrast.helper';

export const Map = styled(LeafletMap)`
  width: 100%;
  height: 459px;
  z-index: 0;
`;

export const PopupStyles = createGlobalStyle`
  .leaflet-zoom-animated{
    bottom: 35px !important;
  }
`;

export const PopupLink = styled.a`
  font-size: 14px;
  color: ${AA_LINK_ON_LIGHT};
  text-decoration: underline;
  &:hover {
    color: ${AA_LINK_HOVER_ON_LIGHT};
    text-decoration: underline;
  }
`;

export const MapTextCard = styled(Card)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 459px;
`;

export const MapContainer = styled.div`
  position: relative;
  width: 100%;
  height: 459px;
`;

export const MapOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background: #eeeeee;
  }
`;

export const OverlayContent = styled.div`
  text-align: center;
  padding: 20px;
  border-radius: 8px;
  background: ${AA_SURFACE};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 2px dashed ${AA_LINK_ON_LIGHT};
`;

export const OverlayTitle = styled.h2`
  margin: 0 0 8px 0;
  color: ${AA_LINK_ON_LIGHT};
  font-size: 18px;
  font-weight: 600;
`;

export const OverlayText = styled.p`
  margin: 0;
  color: ${AA_TEXT_ON_LIGHT};
  font-size: 14px;
`;

export const OverlayIcon = styled.div`
  font-size: 48px;
  color: ${AA_LINK_ON_LIGHT};
  margin-bottom: 16px;

  &::before {
    content: '🗺️';
  }
`;
